import { call, put } from 'redux-saga/effects';
import GetMakeActions from '../redux/GetMakeRedux';
import { api } from './api';


export function* getmakesagas(action: any): Generator<any, void, any> {
  const { make_id } = action;
  const response = yield call(api.getMake, make_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetMakeActions.getMakeSuccess(response.data));
  } else {
    yield put(GetMakeActions.getMakeFailure());
  }
}